import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressButton from '../_utils/progress-button';
import Pluralizer from './pluralizer';
import StoresList from './stores-list';
import CartItemsChangeEvents from './cart-items-change-events';
import translate from '../_utils/tools/translate';
import { isPostalCodeLocal } from '../_utils/validations';
import { builderDispatch } from '../_utils/ui';
import PostalCodeInput from '../_common/postal-code-input';
import deliveryOptionType from './types/delivery-option-type';

class StoreLocator extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};

    this.showSearchForm = this.showSearchForm.bind(this);
    this.handleZipCodeUpdateClick = this.handleZipCodeUpdateClick.bind(this);
    this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this);
  }

  render() {
    const { errorMessage, onSelected, locations } = this.props;
    const { searchFormOpen } = this.state;
    const { zipCode, searching } = this.context;

    if (!isPostalCodeLocal(zipCode) || searchFormOpen || searching) {
      return this.renderSearchForm();
    }

    return (
      <div className="store-locator">
        <div className="d-flex flex-wrap align-items-center" tabIndex="0">
          <h3 className="store-locator-list-heading">
            We found&nbsp;
            <Pluralizer
              count={locations.length}
              singular={`${translate('pickup')} option`}
            />
            &nbsp;near <b className="text-uppercase">{zipCode}</b>
            .&nbsp;
          </h3>
          <button
            className="col-lg-auto btn btn-outline-info btn-lg"
            data-test="store-locator-search-form"
            aria-label={`Change ${translate('zip code')}`}
            onClick={this.showSearchForm}>
            Change
          </button>
        </div>
        <hr />
        <StoresList stores={locations} />
        <small className={classNames({ 'd-none': !errorMessage })}>
          {errorMessage}
        </small>
        <div className="clearfix">
          <button
            className="btn btn-sm btn-secondary col-md-2 float-right"
            onClick={onSelected}>
            Continue
          </button>
        </div>
      </div>
    );
  }

  renderSearchForm() {
    const {
      option: { type },
    } = this.props;
    const { zipCode, searching } = this.context;
    const { zipCodeValid } = this.state;
    const inputId = `zip-code-${type}`;

    return (
      <form
        className="form-inline store-locator-search row"
        onSubmit={this.handleZipCodeUpdateClick}>
        <div className="col-md-4">
          <label htmlFor={inputId}>
            Please enter your {translate('ZIP code')}
          </label>
        </div>
        <div className="col-md-3">
          <PostalCodeInput
            id={inputId}
            initialValue={zipCode}
            onInputRef={(ref) => (this.zipCodeField = ref)}
            onChange={this.handlePostalCodeChange}
            disabled={searching}
            inputClassName="w-100"
            hideError
            hideLabel
            autoFocus
          />
        </div>
        <div className="col-md-2">
          <ProgressButton
            className={classNames(
              'zipcode-search-btn btn btn-xs btn-block btn-info',
              { 'p-0': searching },
            )}
            onClick={this.handleZipCodeUpdateClick}
            disabled={!zipCodeValid || searching}>
            {searching ? (
              <>
                <i
                  className="fas fa-circle-notch fa-spin fa-2x m-1"
                  role="status"
                  aria-hidden="true"
                />
                <span className="sr-only">Loading...</span>
              </>
            ) : (
              'Find'
            )}
          </ProgressButton>
        </div>
      </form>
    );
  }

  showSearchForm(e) {
    e && e.preventDefault();

    this.setState({
      searchFormOpen: true,
      zipCodeValid: isPostalCodeLocal(this.context.zipCode),
    });
  }

  handlePostalCodeChange(e) {
    this.setState({
      zipCodeValid: isPostalCodeLocal(e.target.value),
    });
  }

  handleZipCodeUpdateClick(e) {
    e && e.preventDefault();

    if (!this.state.zipCodeValid) {
      return;
    }

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.ZIP_CODE_CHANGE,
      value: this.zipCodeField.value,
    });

    this.setState({
      searchFormOpen: false,
    });
  }
}

StoreLocator.displayName = 'Store Locator';

StoreLocator.propTypes = {
  errorMessage: PropTypes.string,
  onSelected: PropTypes.func,
  locations: PropTypes.array,
  option: deliveryOptionType,
};

StoreLocator.contextTypes = {
  searching: PropTypes.bool,
  zipCode: PropTypes.string,
};

export default StoreLocator;
